import React from 'react';
import Ingredient from './Ingredient';

function Ingredients(props) {
    const { ingredients } = props;

    let total = ingredients.length;

    return (
        <p className="ingredients flex flex-wrap text-sm italic">
            {ingredients.length === 0 ?
                ("No ingredients.") :
                (ingredients.map((ingredient, i) => <Ingredient ingredient={ingredient} total={total} index={i} key={i} />))}
        </p>
    );
}

export default Ingredients;
